export const CATEGORIES_PAID = [
  {
    name: 'Animals',
    tag: 'animal',
  },
  {
    name: 'Artifacts',
    tag: 'artifact',
  },
  {
    name: 'Art Deco',
    tag: 'art deco',
  },
  {
    name: 'Plants',
    tag: 'plants',
  },
  {
    name: 'Vehicle',
    tag: 'vehicle',
  },
  {
    name: 'Furniture',
    tag: 'furniture',
  },
];
